import CertificateElement from "./certificateElement";
import {certificateElementType} from "~/enums/certificateElementType";
import DynamicImageElement from "./concerns/dynamicImageElement";

export default class DynamicImageCertificateElement extends DynamicImageElement(CertificateElement) {
  type: certificateElementType = certificateElementType.DynamicImage;
  //TODO: Legacy Code: can probably be removed
  workflowStepLabel: string;
  uploadFileLabel: string;
  uploadImageFormElementId: string;

  get dynamicInput(){
    return this.certificate.certificateDynamicInputsArrayDeep.find(x=> x.client_id === this.underlying_variable )
  }

}